const tabValues = require('./tabValues');

module.exports = {
    calendar: {
        name: 'КАЛЕНДАР',
        color: '#D3E2FB',
        tabValues: {
            0: tabValues.calendar.FULL,
            1: true,
            2: tabValues.calendar.PERSONAL,
            3: tabValues.calendar.HR_OTPUK,
            "normative": tabValues.calendar.NORMATIVE_BTN,
        },
        fields: [
            { name: 'Личен график', value: tabValues.calendar.PERSONAL },
            { name: 'Пълен график', value: tabValues.calendar.FULL },
            { name: 'ЧР-Отпуски', value: tabValues.calendar.HR_OTPUK },
            { name: 'ЧР-Справка норматив', value: tabValues.calendar.NORMATIVE_BTN },
        ],
    },
    delivery: {
        name: 'ДОСТАВКИ',
        color: '#FBF3D3',
        tabValues: {
            personal: tabValues.delivery.PERSONAL,
            full: tabValues.delivery.FULL,
            can_add: tabValues.delivery.CAN_ADD,
            can_accept: tabValues.delivery.CAN_ACCEPT,
            // mail_new_requests: tabValues.delivery.MAIL_NEW_REQUEST,
            // mail_confirmed_requests: tabValues.delivery.MAIL_CONFIRMED_REQUEST,
        },
        fields: [
            { name: 'Таб Доставки - само своите заявки', value: tabValues.delivery.PERSONAL },
            { name: 'Таб Доставки - всички заявки', value: tabValues.delivery.FULL },
            { name: 'Може да добавя нови заявки', value: tabValues.delivery.CAN_ADD },
            { name: 'Може да одобрява нови заявки', value: tabValues.delivery.CAN_ACCEPT },
            // { name: 'Получава мейл нотификация при нова заявка', value: tabValues.delivery.MAIL_NEW_REQUEST },
            // { name: 'Получава мейл нотификация при одобрена заявка', value: tabValues.delivery.MAIL_CONFIRMED_REQUEST },
        ],
    },
    inquiry: {
        name: 'СПРАВКИ',
        color: '#D3FBED',
        tabValues: {
            "personal_inquiries": tabValues.inquiry.PERSONAL_INQUIRIES,
            "full_inquiries": tabValues.inquiry.FULL_INQUIRIES,
            "external_inquiry": tabValues.inquiry.EXTERNAL_INQUIRY,
            0: tabValues.inquiry.REPORTS,
            1: tabValues.inquiry.EQUIPMENTS,
            2: tabValues.inquiry.INVENTORY,
            3: tabValues.inquiry.RENTED_MECHANIZATION,
            4: tabValues.inquiry.MATERIALS,
            5: tabValues.inquiry.ACTIVITIES,
            6: tabValues.inquiry.WORKERS,
            7: tabValues.inquiry.BALANCE,
            8: tabValues.inquiry.PLANNED_EXECUTED,
        },
        fields: [
            { name: 'Лични справки', value: tabValues.inquiry.PERSONAL_INQUIRIES },
            { name: 'Пълни справки', value: tabValues.inquiry.FULL_INQUIRIES },
            { name: 'За външни работници', value: tabValues.inquiry.EXTERNAL_INQUIRY },
            { name: 'таб Отчети', value: tabValues.inquiry.REPORTS },
            { name: 'таб Строителна техн.', value: tabValues.inquiry.EQUIPMENTS },
            { name: 'таб Инструменти', value: tabValues.inquiry.INVENTORY },
            { name: 'таб Наета мех.', value: tabValues.inquiry.RENTED_MECHANIZATION },
            { name: 'таб Материали', value: tabValues.inquiry.MATERIALS },
            { name: 'таб Дейности', value: tabValues.inquiry.ACTIVITIES },
            { name: 'таб Работници', value: tabValues.inquiry.WORKERS },
            { name: 'таб Баланс', value: tabValues.inquiry.BALANCE },
            { name: 'таб Планирано/Изпълнено', value: tabValues.inquiry.PLANNED_EXECUTED },
        ],
    },
    reports: {
        name: 'ПЛАН/ОТЧЕТ',
        color: '#D3DFFB',
        tabValues: {
            "planning": tabValues.reports.PLANNING,
            "reporting": tabValues.reports.REPORTING,
            "worker_section": tabValues.reports.WORKER_SECTION,
            "tools_section": tabValues.reports.EQUIPMENTS_SECTION,
            "inventory_section": tabValues.reports.INVENTORY_SECTION,
            "rented_mechanization_section": tabValues.reports.RENTED_MECHANIZATION_SECTION,
            "materials_section": tabValues.reports.MATERIALS_SECTION,
            "activities_section": tabValues.reports.ACTIVITIES_SECTION,
            "prices": tabValues.reports.PRICES,
            "self_reports": tabValues.reports.SELF_REPORTS,
            "self_reports_groups": tabValues.reports.SELF_REPORTS_GROUPS,
            "accept_self_reports": tabValues.reports.ACCEPT_WORKER_REPORTS,
            "accept_own_project_reports": tabValues.reports.ACCEPT_OWN_PROJECT_REPORTS,
        },
        fields: [
            { name: 'Планиране', value: tabValues.reports.PLANNING },
            { name: 'Отчитане', value: tabValues.reports.REPORTING },
            { name: 'Отчет - Раздел Работници', value: tabValues.reports.WORKER_SECTION },
            { name: 'Отчет - Раздел Строителната техника', value: tabValues.reports.EQUIPMENTS_SECTION },
            { name: 'Отчет - Раздел Инструменти', value: tabValues.reports.INVENTORY_SECTION },
            { name: 'Отчет - Раздел Наета мех.', value: tabValues.reports.RENTED_MECHANIZATION_SECTION },
            { name: 'Отчет - Раздел Материали', value: tabValues.reports.MATERIALS_SECTION },
            { name: 'Отчет - Раздел Дейности', value: tabValues.reports.ACTIVITIES_SECTION },
            { name: 'Отчет - цени', value: tabValues.reports.PRICES },
            { name: 'Има право само да се самоотчита', value: tabValues.reports.SELF_REPORTS },
            { name: 'Има право само да самоотчита други работници и групи', value: tabValues.reports.SELF_REPORTS_GROUPS },
            { name: 'Приема самоотчети от всички работници', value: tabValues.reports.ACCEPT_WORKER_REPORTS },
            { name: 'Приема самоотчети само в обекти, в които е отчетник', value: tabValues.reports.ACCEPT_OWN_PROJECT_REPORTS },
        ],
    },
    companies: {
        name: 'ОТДЕЛИ',
        color: '#EED8C2',
        tabValues: {
            "companies_projects": tabValues.companies.COMPANIES_PROJECTS,
            "mechanization_tab": tabValues.companies.MECHANIZATION_TAB,
            "production_tab": tabValues.companies.PRODUCTION_TAB,
            "construction_tab": tabValues.companies.CONSTRUCTION_TAB
        },
        fields: [
            { name: 'Отдели/Проекти', value: tabValues.companies.COMPANIES_PROJECTS },
            { name: 'отдел Механизация - Автоматично да се добави като отчетник', value: tabValues.companies.MECHANIZATION_TAB },
            { name: 'отдел Производство - Автоматично да се добави като отчетник', value: tabValues.companies.PRODUCTION_TAB },
            { name: 'отдел Строителство - Автоматично да се добави като отчетник', value: tabValues.companies.CONSTRUCTION_TAB }
        ],
    },
    inventory: {
        name: 'ИНВЕНТАР',
        color: '#FBD3D6',
        tabValues: {
            "tools_own": tabValues.inventory.TOOLS_OWN,
            "tools_all": tabValues.inventory.TOOLS__ALL,
            "mechanizations_own": tabValues.inventory.MECHANIZATIONS_OWN,
            "mechanizations_all": tabValues.inventory.MECHANIZATIONS_ALL,
            "heavy_machinery_own": tabValues.inventory.HEAVY_MACHINERY_OWN,
            "heavy_machinery_all": tabValues.inventory.HEAVY_MACHINERY_ALL,
            "heavy_machinery_mails": tabValues.inventory.HEAVY_MACHINERY_MAILS,
            "heavy_machinery_inquiry": tabValues.inventory.HEAVY_MACHINERY_INQUIRY,
            "lps_own": tabValues.inventory.LPS_OWN,
            "lps_all": tabValues.inventory.LPS_ALL,
            "lps_returned_on": tabValues.inventory.LPS_RETURNED_ON,
            "lps_scrapped_on": tabValues.inventory.LPS_SCRAPPED_ON,
            "pernik_own": tabValues.inventory.PERNIK_OWN,
            "pernik_all": tabValues.inventory.PERNIK_ALL,
            "car_own": tabValues.inventory.CAR_OWN,
            "car_all": tabValues.inventory.CAR_ALL,
            "car_mails": tabValues.inventory.CAR_MAILS,
            "car_inquiry": tabValues.inventory.CAR_INQUIRY,
        },
        fields: [
            { name: 'таб Инструменти - само свои и свободни', value: tabValues.inventory.TOOLS_OWN },
            { name: 'таб Инструменти - всички', value: tabValues.inventory.TOOLS__ALL },
            { name: 'таб Строителна техника - само свои', value: tabValues.inventory.MECHANIZATIONS_OWN },
            { name: 'таб Строителна техника - всички', value: tabValues.inventory.MECHANIZATIONS_ALL },
            { name: 'Таб Тежка Механизация - само свои', value: tabValues.inventory.HEAVY_MACHINERY_OWN },
            { name: 'Таб Тежка Механизация - всички', value: tabValues.inventory.HEAVY_MACHINERY_ALL },
            { name: 'Таб Тежка Механизация - Получава мейл нотификации при наближаващи срокове или обслужвания', value: tabValues.inventory.HEAVY_MACHINERY_MAILS },
            { name: 'Таб Тежка Механизация - Прави справка Разходи за поддръжка', value: tabValues.inventory.HEAVY_MACHINERY_INQUIRY },
            { name: 'таб Служебен инвентар и ЛПС - само свои', value: tabValues.inventory.LPS_OWN },
            { name: 'таб Служебен инвентар и ЛПС - всички', value: tabValues.inventory.LPS_ALL },
            { name: 'таб Служебен инвентар и ЛПС - дата връщане ', value: tabValues.inventory.LPS_RETURNED_ON },
            { name: 'таб Служебен инвентар и ЛПС - дата бракуване', value: tabValues.inventory.LPS_SCRAPPED_ON },
            { name: 'Таб ЗАВОД ПЕРНИК - само свои', value: tabValues.inventory.PERNIK_OWN },
            { name: 'Таб ЗАВОД ПЕРНИК - всички', value: tabValues.inventory.PERNIK_ALL },
            { name: 'Таб Автомобили - само свои', value: tabValues.inventory.CAR_OWN },
            { name: 'Таб Автомобили - всички', value: tabValues.inventory.CAR_ALL },
            { name: 'Таб Автомобили - Получава мейл нотификации при наближаващи срокове или обслужвания', value: tabValues.inventory.CAR_MAILS },
            { name: 'Таб Автомобили - Прави справка Разходи за поддръжка', value: tabValues.inventory.CAR_INQUIRY },
        ],
    },
    users: {
        name: 'ПОТРЕБИТЕЛИ',
        color: '#C4D8B7',
        tabValues: {
            "users_info": tabValues.users.USERS_INFO,
            "users_inventory_own": tabValues.users.USERS_INVENTORY_OWN,
            "users_inventory_all": tabValues.users.USERS_INVENTORY_ALL,
            "users_roles": tabValues.users.USERS_ROLES
        },
        fields: [
            { name: 'Потребители - основна информация', value: tabValues.users.USERS_INFO },
            { name: 'Потребители - Служебен инвентар и ЛПС (личен)', value: tabValues.users.USERS_INVENTORY_OWN },
            { name: 'Потребители - Служебен инвентар и ЛПС (на останалите)', value: tabValues.users.USERS_INVENTORY_ALL },
            { name: 'Роли', value: tabValues.users.USERS_ROLES },
        ],
    },
    log: {
        name: 'ЛОГ',
        color: '#D6D6D6',
        tabValues: {
            "log": tabValues.log.LOG,
        },
        fields: [
            { name: 'ЛОГ-Дневник', value: tabValues.log.LOG },
        ],
    },
};
